import React from "react";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

const Bulletin = ({ productInquiry, oneOnOneInquiry, productReview }) => {
  return (
    <div>
      <div className="w-[15rem] ">
        <div className="flex justify-between">
          <TitlePage size="text-[14px]" title="게시글" />
          <Link
            to="/bulletin-board"
            className="cursor-pointer text-title-grey flex ml-2"
          >
            게시판 관리
            <ChevronRightIcon className="-mt-[18px]" width={15} />
          </Link>
        </div>
        <div className="w-full h-[9.5rem] space-y-3 p-3 shadow-dashboard">
          <div className="flex w-[70%] mt-5 justify-between">
            <p>상품문의</p>
            <p>{productInquiry}</p>
          </div>
          <div className="flex w-[70%] justify-between">
            <p>1:1 문의</p>
            <p>{oneOnOneInquiry}</p>
          </div>
          <div className="flex w-[70%] justify-between">
            <p>상품 리뷰</p>
            <p>{productReview}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bulletin;
